// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface RoleTranslationModel {
    name: string;
    description: string;
}

export type VmiUserState = Readonly<{
    isLoading: boolean;
    roleLabels?: Record<string, string>;
    assignedRoles: string[];
}>;

export const initialXVmiUserState: VmiUserState = {
    isLoading: false,
    roleLabels: undefined,
    assignedRoles: [],
};

const reducer = {
    "xVmiUser/SetLoading": (draft: Draft<VmiUserState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "xVmiUser/CompleteLoading": (draft: Draft<VmiUserState>, action: { roleLabels: RoleTranslationModel[] }) => {
        draft.isLoading = false;
        const roleLabels: Record<string, string> = {};
        action.roleLabels.forEach(({ name, description }) => {
            roleLabels[name] = description;
        });
        draft.roleLabels = roleLabels;
    },
    "xVmiUser/SetAssignedRoles": (draft: Draft<VmiUserState>, action: { assignedRoles: string[] }) => {
        draft.assignedRoles = action.assignedRoles;
    },
};

const xVmiUser = createTypedReducerWithImmer(initialXVmiUserState, reducer);
(reducers as any).xVmiUser = xVmiUser;

export type XVmiUserState = {
    xVmiUser: VmiUserState;
} & ApplicationState;

type XVmiUserReducers = {
    [key: string]: typeof xVmiUser;
};

export type XVmiUserActions = Parameters<XVmiUserReducers[keyof XVmiUserReducers]>[1] | AnyAction;
